import { Platform } from 'src/environment';
import { appConfigFactory } from '../../factories';
import { AnyToggleValue } from '../types';
import { FeatureToggleStrategy } from './FeatureToggleStrategy';

export abstract class BaseToggleStrategy<
  T,
> implements FeatureToggleStrategy<T> {
  constructor(private readonly appConfig: AppConfig = appConfigFactory()) {}

  public abstract determineToggleValue(toggleValue?: AnyToggleValue): T;
  public abstract isValidToggle(toggleValue: AnyToggleValue): boolean;

  protected getTargetedValue<ToggleValueType>(
    toggleValue?: ToggleValue<ToggleValueType>,
  ): ToggleValueType {
    const { platforms, value } = toggleValue ?? {};
    let rv: ToggleValueType = value;
    if (platforms && this.platform in platforms) {
      rv = platforms[this.platform];
    }
    return rv;
  }

  private get platform(): Platform {
    return this.appConfig.platform;
  }
}
